import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { environment } from '../../../environments/environment';

import { NotificationsService } from '../../_services/notifications.service';
import { SelectItem } from 'primeng/primeng';
import { ImportDataService } from '../../_services/import-data.service';
import { Ship } from '../../_models/ship';
import { ShipService } from '../../_services/ship.service';
import { Form } from '../../shared/form';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorHandler } from '../../shared/http-error-handler';

@Component({
  selector: 'app-import-view',
  templateUrl: './import-view.component.html',
  styleUrls: ['./import-view.component.css'],
})
export class ImportViewComponent extends Form implements OnInit {
  @Input() filterParams: string;
  protected maxRecordsAllowed = environment.maxExportRecords;
  protected recordsCount: number;
  protected error: boolean;
  ships: SelectItem[];
  selectedShip: Ship[];
  years: SelectItem[];
  selectedYear: any;
  excelType: string;
  excelSpanishType: string;
  excelTypes: string[] = ['Capturas', 'Descartes', 'Desembarques'];
  shipName: string;
  ship: Ship;
  validSelectedFile: boolean;
  msgError: string;
  msgSuccess: string;
  msgWarning: string;
  loading: boolean;

  constructor(
    private importDataService: ImportDataService,
    private notificationsService: NotificationsService,
    private shipService: ShipService,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.validSelectedFile = false;
    this.loading = false;
  }

  createArrayRange(start, end) {
    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  }

  getSelectedYears() {
    this.years = this.createArrayRange(2013, new Date().getFullYear());
  }

  ngOnInit(): void {
    this.getShips();
    this.getSelectedYears();
  }

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      let validFile = true;
      let errorFileMesage = '';
      // First of all we split by . to remove the extension of the file from the name, and later split by _ to get the two diferents fields
      // the type of the data(Capturas, Descartes o Desembarques) and the name of the ship. In the name of the ship we split by ( - and 'copia' to
      // remove the phrase that add the Operative System to the duplicate file names
      // example names:
      // Normal file name:
      // Capturas_ERES UN PILAR.xlsx
      // Duplicate file name in ubuntu:
      // Capturas_ERES UN PILAR(1).xlsx
      // Duplicate file name in windows:
      // Capturas_ERES UN PILAR - copia.xlsx
      // Duplicates in mac:
      // Capturas_ERES UN PILAR copia .xlsx
      const fileExcelType = selectedFile.name.split('_')[0];
      let fileShipName = selectedFile.name.split('.')[0].split('_')[1].split('(')[0].split('-')[0].split('copia')[0];

      // If finish in space we remove it
      if (fileShipName.slice(-1) === ' ') {
        fileShipName = fileShipName.slice(0, -1);
      }

      if (this.excelTypes.includes(fileExcelType)) {
        this.excelSpanishType = fileExcelType;
        if (fileExcelType === 'Capturas') {
          this.excelType = 'captures';
        } else if (fileExcelType === 'Descartes') {
          this.excelType = 'discards';
        } else if (fileExcelType === 'Desembarques') {
          this.excelType = 'debarkations';
        }
      } else {
        validFile = false;
        errorFileMesage = 'ERROR: El nombre del archivo no es válido, por favor prueba a volver a descargarlo y subirlo sin modificar nada';
      }
      const searchedShip = this.ships.find((item) => item.label === fileShipName);
      if (searchedShip) {
        this.shipName = fileShipName;
        this.ship = searchedShip.value;
      } else {
        validFile = false;
        errorFileMesage =
          'ERROR: No se ha encontrado un barco con el nombre ' +
          fileShipName +
          ' .Comprueba en el apartado BARCOS que el barco tiene el nombre correcto';
      }
      this.validSelectedFile = validFile;
      this.msgError = errorFileMesage;
    }
  }

  getShips() {
    this.shipService.list(1, 10000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', true);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  importFile(event) {
    event.preventDefault();
    this.loading = true;
    this.msgError = '';
    this.msgSuccess = '';
    const fileInput = <HTMLInputElement>document.getElementById('fileInput');
    if (fileInput.files.length > 0) {
      const importFile = fileInput.files[0];
      this.importDataService.importFile(this.excelType, String(this.ship.id), importFile).subscribe(
        (response) => {
          if (response.msgError) {
            this.msgError = response.msgError;
          } else {
            this.msgSuccess = 'Archivo procesado. Se han añadido ' + response.numImportedRows + ' lineas';
            if (response.numFailedRows > 0) {
              this.msgError = 'Han fallado las siguientes ' + response.numFailedRows + ' lineas: ' + response.failedLines;
            }
          }
          this.loading = false;
        },
        (error) => {
          const msg = this.httpErrorHandler.handleHttpError(error)[0];
          this.notificationsService.notify('error', 'Error', msg);
          this.loading = false;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/import/import-view/import-view.component.ts